var card_product_item_ele = null;
var card_product_form_page = null;
function init_product_card(){
    document.querySelectorAll('.quick-buy-btn').forEach(btn => {
        btn.addEventListener('click', function() {
            $('.quick-buy-modal').hide();
            $('.size-option').removeClass('active');
            $('.size-select').show();
            // $('.color-select').show();
            $('.color-select-tip').html('select size');
            const productId = btn.dataset.productId;
            const product_title = btn.dataset.title;
            //获取当前父元素的父元素
            card_product_item_ele = btn.closest('.product-card');
            card_product_form_page = card_product_item_ele.getAttribute('data-formPage');
            console.log('点击进来的');  
            console.log(card_product_form_page);
            card_product_item_ele.querySelector('#modal-' + productId).style.display = 'flex';
            const colorSelect = card_product_item_ele.querySelector('#size-' + productId);
            colorSelect.style.display = 'grid'

             updateSizeOptions(productId, product_title);
        });
    });
document.querySelectorAll('.mobile-quick-buy-btn').forEach(btn => {
    btn.addEventListener('click', function() {
        $('.quick-buy-modal').hide();
        $('.size-option').removeClass('active');
         $('.size-select').show();
        // $('.color-select').show();
        $('.color-select-tip').html('select size');
        // console.log('点击进来的');
        card_product_item_ele = btn.closest('.product-card');
        const productId = btn.dataset.productId; //$(this).attr('data-product-id'); 
         const product_title = btn.dataset.title;
        card_product_item_ele.querySelector('#modal-' + productId).style.display = 'flex';
        const colorSelect = card_product_item_ele.querySelector('#size-' + productId);
        colorSelect.style.display = 'grid'
         updateSizeOptions(productId, product_title);
    });
});

// 关闭弹框
document.querySelectorAll('.close').forEach(span => {
    span.addEventListener('click', function() {
        const productId = span.dataset.productId;
        card_product_item_ele.querySelector('#modal-' + productId).style.display = 'none';
    });
});

$('.modal_close_icon').on('click',function(){
     $(this).parent().parent().hide();
    $(this).parent().parent().find('.size-select').show();
    // $(this).parent().parent().find('.color-select').show();
    $(this).parent().parent().find('.color-select-tip').html('select color');
});

    
$('.quick-buy-modal-mask').on('click', function() {
    $(this).parent().hide();
    $(this).parent().find('.size-select').show();
    // $(this).parent().find('.color-select').show();
    $(this).parent().find('.color-select-tip').html('select color');
})

}

// 选择颜色
function selectColor(element, productId, selectedColor, product_title) {
    const colorSelect = card_product_item_ele.querySelector('#color-' + productId);
    const sizeSelect = card_product_item_ele.querySelector('#size-' + productId);
    const addToCartBtn = card_product_item_ele.querySelector('#add-to-cart-' + productId);
    // console.log(element)
    // console.log(this)
    $(element).parent().prev('.color-select-tip').html('select size');
    // 更新颜色显示
    // colorSelect.querySelector('.color-option').textContent = selectedColor;

    // 更新尺码选项
    // updateSizeOptions(productId, selectedColor, colorSelect, product_title);

    // 启用加入购物车按钮
   addToCartBtn? addToCartBtn.disabled = false : ''
}

// 更新尺码选项（基于颜色）
function normalizeQuickBuyVariants(variants) {
    if (!Array.isArray(variants)) {
        return [];
    }
    if (variants.length === 0 || typeof variants[0] === 'object') {
        return variants;
    }
    const grouped = [];
    let buffer = [];
    for (let item of variants) {
        item = String(item).replace(/^'|'$/g, '').trim();
        buffer.push(item);
        if (item.endsWith('}')) {
            grouped.push(buffer.join(','));
            buffer = [];
        }
    }
    return grouped.map(raw => {
        const fixed = raw
            .replace(/^{/, '')
            .replace(/}$/, '')
            .split(',')
            .map(pair => {
                const [key, ...rest] = pair.split(':');
                const value = rest.join(':').trim();
                const cleanKey = `"${key.trim()}"`;
                const cleanValue = `"${value.replace(/"/g, '\\"').trim()}"`;
                return `${cleanKey}: ${cleanValue}`;
            })
            .join(', ');
        return JSON.parse(`{${fixed}}`);
    });
}

function variantValueIsTrue(value) {
    return value === true || String(value).toLowerCase() === 'true';
}

function quickBuyVariantQuantity(value) {
    const quantity = Number(value);
    return Number.isFinite(quantity) ? quantity : 0;
}

function isQuickBuyPreOrder(v) {
    return Boolean(v.pre_order_ship_date) && v.inventory_policy === 'continue' && quickBuyVariantQuantity(v.inventory_quantity) <= 0;
}

function updateSizeOptions(productId, product_title) {
    const sizeSelect = card_product_item_ele.querySelector('#size-' + productId);
    const variants = normalizeQuickBuyVariants(JSON.parse(card_product_item_ele.querySelector('#variants-' + productId).textContent));

    const sizes = variants;

// console.log(parsed);
//     return;
    // 清空现有尺码选项
    // sizeSelect.innerHTML = '<div class="size-option" data-size="">请选择尺码</div>';
    sizeSelect.innerHTML = ''
        // 筛选出该颜色对应的尺码
    // const sizes = variants.filter(v => v.option1 === selectedColor);
    // console.log('sizes:', sizes);
    sizes.forEach(v => {
        const option = document.createElement('div');
        option.classList.add('size-option');
        option.dataset.size = v.option2; // 尺码
	        option.dataset.title = product_title
	        const isAvailable = variantValueIsTrue(v.available);
	        const isPreOrder = isQuickBuyPreOrder(v);
        //no_notify_me_selected and option_value.available  == false
        // 如果没有库存，禁用该尺码选项
	        if (!isAvailable && !isPreOrder) {
            // option.style.backgroundColor = '#ccc';
            // option.style.cursor = 'not-allowed';
            option.innerHTML = '<img class="size-email-icon" src="https://cdn.shopify.com/s/files/1/0601/6981/4121/files/Shopicon.svg?v=1756220751" /><span class="size-text-disabled">' + v.option2 + '</span>'
            option.classList.add('disabled');
            option.disabled = true;
	        } else if (isPreOrder) {
	            option.textContent = v.option2 + ' - Ship by ' + v.pre_order_ship_date;
	            option.classList.add('pre-order');
	        } else {
            option.textContent = v.option2;
        }

        option.addEventListener('click', function() {
	            if (!variantValueIsTrue(v.available) && !isQuickBuyPreOrder(v)) {
                $('.notify-me-pupopbox').fadeIn(300).addClass('card_notify_me_pupopbox');
                var notify_product_size_name = $(this).attr('data-size');
                var notify_product_title = $(this).attr('data-title');
                $(this).addClass('active').siblings().removeClass('active');
                $('#notify_form_product_title').val(notify_product_title);
                $('#notify_form_product_size').val(notify_product_size_name);
                return
            } else {
                addToCart(productId, v.id, this);
            }
        });

        sizeSelect.appendChild(option);

    });
    // colorSelect.style.display = 'none'
    sizeSelect.style.display = 'grid'
}

// 选择尺码
function selectSize(productId, selectedSize, variantId) {
    const sizeSelect = card_product_item_ele.querySelector('#size-' + productId);
    const addToCartBtn = card_product_item_ele.querySelector('#add-to-cart-' + productId);

    // 更新尺码显示
    // sizeSelect.querySelector('.size-option').textContent = selectedSize;

    // 启用加入购物车按钮
    addToCartBtn.disabled = false;
    addToCartBtn.onclick = function() {
        addToCart(productId, variantId);
    };
}
var createCartPromise_two = () => {
    return fetch(`${Shopify.routes.root}cart.js`).then(res => res.json())
};
// 添加到购物车
function addToCart(productId, variantId, element) {
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
    const quantity = document.getElementById('quantity-' + productId).value;
    var cart_section_id = localStorage.getItem('cart_id');
    fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                items: [{
                    id: variantId,
                    quantity: quantity
                }],
                sections: cart_section_id
            })
        })
        .then(response => {
                if (response.ok) {
                    return response.json()
                } else {
                    if (response.status == 422) {
                        document.dispatchEvent(new CustomEvent('toast:show', { detail: { message: 'The maximum quantity of this item is already in your cart.', tone: 'error' } }));
                    }
                }

            }

        )
        .then(async data => {
            if (data) {
                document.getElementById('modal-' + productId).style.display = 'none';
                let return_html = data.sections[cart_section_id];
                const cartDrawerSection = document.querySelector('#shopify-section-' + cart_section_id);
                if (cartDrawerSection) {
                    cartDrawerSection.remove();
                }
                //获取 
    //             document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
    //   bubbles: true,
    //   detail: {
    //     baseEvent: "variant:add",
    //     cart: cartContent
    //   }
    // }));
                //获取class nav-meun-cart-count 下的 span 元素 并更新数量
                // console.log(document.querySelector('.nav-meun-cart-count span'))
                // console.log(data.items.reduce((sum, item) => sum + item.quantity, 0))\
                let res = await createCartPromise_two();
                document.body.insertAdjacentHTML('beforeend', return_html);
                
                if (res) {
                    if (res.item_count > 0) {
                        document.querySelector('.nav-meun-cart-count').removeAttribute('hidden');
                    }
                    document.querySelectorAll('.nav-meun-cart-count span').forEach((el) => {
                        el.innerHTML = res.item_count;
                    });
                    //  
                    //触发 自定义事件 cart:refresh
                    if(card_product_form_page == 'cart_drawer'){
                         document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: res } }));
                    }else{
                        document.querySelector('.nav-meun-rt-item-cart-open').click();
                    }
                    
                }
                $('.quick-buy-modal').hide();
                $(element).parent().hide();
                $(element).parent().prev().find('.size-select').show();
                $(element).parent().prev().find('.color-select-tip').html('select size');
            }
        })
        .catch(error => {
            console.error('Error:', error);
        }).finally(() => {
            document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
        });
}

init_product_card();
document.addEventListener('DOMContentLoaded', function() {
const searchPanel = document.querySelector('search-result-panel');
if(searchPanel){
    searchPanel.addEventListener('searchComplete', (e) => {
        init_product_card();
    });
}
});

//监听 cart:refresh 事件 执行 init_product_card
document.addEventListener('swiper:cart', function(e) {
    // console.log('swiper:cart 事件触发');
    init_product_card();
});
//监听 facet:update 事件 执行 init_product_card
document.addEventListener('facet:update', function(e) {
    console.log('facet:update 事件触发');
    console.log(e);
    if(e.detail.scrollTo == "#collection"){
        setTimeout(function(){
             init_product_card();
        },3000)
    }
   // init_product_card();
});
//监听自定义事件 predictive-search:results
document.addEventListener('predictive-search:results', function(event) {
    if(window.innerWidth < 1025){
        if($('.predictive-search__suggestions').attr('data-total_results') != undefined){
              $('.mobile-search-top span').text($('.predictive-search__suggestions').attr('data-total_results') + ' results');
        }else{
            $('.mobile-search-top span').text('0 results');
        }
       
    }
     init_product_card();
});
